import React, { useEffect, useState } from "react";
import AnimateSpringUp from "@common/animations/AnimateSpringUp";
import { getRandomInt } from "@common/utils/utils";

const MascotBody = ({ type, style }) => {
  return (
    <object
      type="image/svg+xml"
      data={`/static/${type}-body.svg`}
      alt="loading"
      style={{ ...style }}
    />
  );
};

const MascotHand = ({ type, style }) => {
  return (
    <object
      type="image/svg+xml"
      data={`/static/${type}-hands.svg`}
      alt="loading"
      style={{ ...style }}
    />
  );
};

export const TYPE_DRAGON = "dragon";
export const TYPE_SANTA = "santa";
export const TYPE_REINDEER = "reindeer";
export const TYPE_CAISHEN = "csy";

const Mascot = ({ type = TYPE_DRAGON, enabled, top, right }) => {
  const [repeatDelay] = useState(getRandomInt(5, 15));
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setHidden(false), 3000);
    return () => clearTimeout(timeout);
  }, []);

  if (hidden || !enabled) {
    return <></>;
  }

  return (
    <>
      <div style={{ position: "absolute", top: top || -45, right: right || 8 }}>
        <div style={{ position: "relative", width: 32, height: 60 }}>
          <AnimateSpringUp
            initialYOffset={20}
            finalZIndex={50}
            repeatDelay={repeatDelay}
            style={{ position: "absolute", bottom: 1.5, right: 4 }}
          >
            <MascotHand type={type} />
          </AnimateSpringUp>
          <AnimateSpringUp
            initialYOffset={60}
            bounce={0.2}
            repeatDelay={repeatDelay}
            style={{ position: "absolute", bottom: 5 }}
          >
            <MascotBody type={type} />
          </AnimateSpringUp>
        </div>
      </div>
    </>
  );
};

export default Mascot;
